export const layoutStateGroup = state => {
  return[ state.authentication.token,
    state.authentication.language,
    state.dashboard.menuLevel1,
    state.dashboard.menuLevel2,
    state.dashboard.online,
    state.authentication.content,
    state.utils.sideBarCollapse,
    state.utils.sideMenu]
};